import { cn, Image } from '@ds';
import { MdOutlinePhoneInTalk } from 'react-icons/md';
import { getColorsByOrganType, getOrganImg } from '@/utils/helpers';
import { OrganType } from '@/api/apis/case';

type CLOrganIconsProps = {
  organs: OrganType[] | null;
};

export const CLOrganIcons = ({ organs }: CLOrganIconsProps) => {
  if (!organs?.length) return null;

  return (
    <div className="flex gap-1 p-1 items-center w-fit rounded-full bg-indigo-80">
      {organs.map((organ) => (
        <div
          key={organ}
          className={cn('w-6 h-6 rounded-full flex items-center justify-center', getColorsByOrganType(organ).bg40)}
        >
          <Image src={getOrganImg(organ)} alt={organ} />
        </div>
      ))}
      <MdOutlinePhoneInTalk className="text-indigo-20 w-6 h-6" />
    </div>
  );
};
